import React from 'react'
import SortContainer from '../SortContainer'
import { ItemTypes } from '../../constants'
import ListItem from '../ListItem'
import t from 'tcomb-form'
import FormGroup from './FormGroup'

export default class FormList extends t.form.List {

  reorder = (items) => {
    this.onChange(
      items.map(item => item.value),
      items.map(item => item.key),
      this.props.ctx.path,
      'reorder'
    )
  }

  onRemove = (item) => {
    const value = this.state.value.slice()
    const keys = this.state.keys.slice()
    const index = keys.indexOf(item.key)
    value.splice(index, 1)
    keys.splice(index, 1)
    this.onChange(value, keys, this.props.ctx.path.concat(index), 'remove')
  }

  renderItem = (item) => {
    return <ListItem onRemove={this.onRemove.bind(this, item)}>{item.input}</ListItem>
  }

  getTemplate () {
    return locals => {
      const items = locals.items.map((item, i) => ({...item, value: locals.value[i]}))
      return <FormGroup className='form-list' locals={locals}>
        <SortContainer
          itemType={ItemTypes.FORM_LIST}
          items={items}
          didSort={this.reorder}
          renderItem={this.renderItem}
        />
        <button type='button' className='btn' onClick={locals.add.click}>Add</button>
      </FormGroup>
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/FormList.js